import { isIE } from '@/assets/utils'
export default class Common {
  // 1. 下载文件
  downloadFile (url, target) {
    if (!url){
      return
    }
    if (isIE()) {
      var elemIF = document.createElement('iframe')
      elemIF.src = url
      elemIF.style.display = 'none'
      document.body.appendChild(elemIF)
    } else {
      var eleLink = document.createElement('a')
      eleLink.style.display = 'none'
      eleLink.href = url
      if (target) {
        eleLink.target = target
      }
      // 其他浏览器
      // console.log('222222222222222')
      const event = new MouseEvent('click', {
        bubbles: false, // 是否可以冒泡
        cancelable: true // 是否可以阻止事件默认行为
        // view: window // 事件的AbstractView对象引用，这里其实指向window 对象
      })
      eleLink.dispatchEvent(event)
    }
    // 触发点击
    // document.body.appendChild(eleLink);
    // eleLink.click();
    // 然后移除
    // document.body.removeChild(eleLink);
  }
}
